
import { RadioGroup } from "@/components/ui/radio-group";
import { Label } from "@/components/ui/label";
import { MessageTone } from "@/types/message";
import ToneOption from "./ToneOption";

interface ToneSelectorProps {
  selectedTone: MessageTone;
  onToneChange: (value: string) => void;
  availableToneValues: MessageTone[];
}

// All available tone options
const allTones: {value: MessageTone, label: string, description: string, isPro?: boolean}[] = [
  { value: "legal", label: "Legal & Formal", description: "Emphasizes rights and legal requirements", isPro: true },
  { value: "polite", label: "Polite but Firm", description: "Professional and assertive" },
  { value: "aggressive", label: "Aggressive & Direct", description: "Strong demands and clear deadlines", isPro: true },
  { value: "friendly", label: "Customer-Friendly", description: "Accommodating and relationship-focused" },
  { value: "custom", label: "Custom Tone", description: "Provide your own instructions below", isPro: true }
];

const ToneSelector = ({ selectedTone, onToneChange, availableToneValues }: ToneSelectorProps) => {
  console.log("=== TONE SELECTOR RENDER ===");
  console.log("Current selected tone:", selectedTone);
  console.log("Available tones:", availableToneValues);
  console.log("All tones:", allTones.map(t => ({ value: t.value, accessible: availableToneValues.includes(t.value) })));

  const handleValueChange = (value: string) => {
    console.log("RadioGroup value change:", value);
    onToneChange(value);
  };

  return (
    <div className="space-y-2">
      <Label>Select Tone</Label>
      <RadioGroup
        value={selectedTone}
        onValueChange={handleValueChange}
        className="gap-3"
      >
        {allTones.map((tone) => {
          const isAccessible = availableToneValues.includes(tone.value);
          console.log(`Tone ${tone.value}: accessible=${isAccessible}, selected=${selectedTone === tone.value}`);
          return (
            <ToneOption
              key={tone.value}
              tone={tone}
              isAccessible={isAccessible}
            />
          );
        })}
      </RadioGroup>
    </div>
  );
};

export default ToneSelector;
